import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTitle } from '../../../Application';
import PasswordNewView from '../../../ui/components/PasswordNew/PasswordNew';
import { setNewPassword} from "../../../connectors/Users/actions";
import log from 'loglevel'

import {t} from 'i18next'
import toast from '../../../utils/ToasterService';
import { pingURL, sendRequest } from '../../../services/api/apiClient';

const title = 'Passwort zurücksetzen';

const mapStateToProps = state => ({
    title: state.application.title,
});

const mapDispatchToProps = dispatch => ({
    setNewPassword: (password, successCb, errorCb) => dispatch(setNewPassword(password, successCb, errorCb))
});

/**
 * Registration
 */
class PasswordNew extends PureComponent {
    static propTypes = {
    }

    static defaultProps = {
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        log.debug("TOKEN", params.token);
    }

    checkConnectionToServer=()=>{
        sendRequest('get', pingURL)
        .then(() => {
          //console.log('Response Ok: Server working!');
        })
        .catch(error => {
          //console.error('Cannot Connect to Server:', error);
          //Server Failure Toast here
          toast.error(t('Global.toast_server_disconnect'));
        });
      }

    render() {
        this.checkConnectionToServer()
        return (
            <PasswordNewView onSetNewPassword={this.props.setNewPassword}
                             router={this.props.history}
            />
        );
    }
}

export default withTitle(withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordNew)), title);
